<template>
  <div class="main">
    <div class="header">
      <my-header />
    </div>
    <main-body class="body" />
    <div class="footer">
      <a class="icp" target="_blank" href="https://beian.miit.gov.cn/">苏ICP备2025193849号</a>
    </div>


  </div>
</template>

<script>
import MainBody from '@/layout/components/mainBody.vue'
import MyHeader from '@/layout/components/myHeader.vue'
export default {
  name: 'MainLayout',
  components: {
    MainBody,
    MyHeader
  }
}
</script>

<style scoped lang="less">

.body {
  width: 100%;
  height: calc(100vh - 70px - 30px);
  padding: 20px;
  overflow: auto;
}

.icp {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #4a6278;
  text-decoration-line: none;
  height: 30px;
}
</style>
